import React, { useState } from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  DialogContent,
  DialogActions,
  DialogTitle,
  Dialog,
  Typography,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import DialogTransition from "@icarius-common/dialogTransition";

const ApproveDialog = (props) => {

  const [isPhaseOne, setIsPhaseOne] = useState(true);

  const { open, data, handleClose, handleApprove } = props;

  const submit = () => {
    if (isPhaseOne) {
      setIsPhaseOne(false);
    } else {
      handleApprove();
      handleClose();
    }
  }

  const phaseOneContent = (
    <Typography className="whiteText" style={{ fontSize: '1.1rem' }}>
      {getLocalizedString("areYouSureYouWantToApproveTheCalculationProcessAndMoveItToTheHistory")}
    </Typography>
  )

  const phaseTwoContent = (
    <>
      <Typography className="whiteText" style={{ marginBottom: 16, fontSize: '1.4rem', fontWeight: 600 }}>
        {getLocalizedString("attention")}:
      </Typography>
      <Typography className="whiteText">
        {getLocalizedString("approvingProcessAndPassingItToHistoryMeansNoRecalculations")}
      </Typography>
      <Typography className="whiteText">
        {getLocalizedString("assumedAllReportsPaymentsAndAccountingDone")}
      </Typography>
      <Typography className="whiteText" style={{ marginTop: 16 }}>
        {getLocalizedString("processApprovalSavesDataInHistoryForFutureQueriesAndUpdatesCalculations")}
      </Typography>
      <Typography className="whiteText" style={{ marginTop: 16, fontSize: '1.4rem', fontWeight: 600 }}>
        {getLocalizedString("confirmApproveProcessAndMoveToHistoric")}
      </Typography>
    </>
  )

  return (
    <Dialog
      TransitionComponent={DialogTransition}
      open={open}
      scroll={"paper"}
      maxWidth={"md"}
      fullWidth
    >
      <DialogTitle>
        {`${getLocalizedString("processApproval")}: ${data['Descripción']}`}
        <DialogTitleDivider />
      </DialogTitle>
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <DialogContent style={{ paddingTop: 0 }}>
        {isPhaseOne ? phaseOneContent : phaseTwoContent}
      </DialogContent>
      <DialogActions>
        <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
        <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("accept")} />
      </DialogActions>
    </Dialog>
  );
}

export default ApproveDialog;
